module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-left-dots-5734706a.svg";